import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal px-4 md:px-6 py-3"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  class: "flex items-center gap-4 md:gap-6"
};
const _hoisted_4 = {
  class: "flex items-center gap-3"
};
const _hoisted_5 = {
  class: "list-page-heading-main hidden sm:block"
};
const _hoisted_6 = {
  class: "text-xs text-slate-500"
};
const _hoisted_7 = {
  class: "hidden md:flex items-center bg-slate-100 rounded-lg p-1"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "flex items-center gap-2 md:gap-3"
};
const _hoisted_10 = {
  class: "flex items-center gap-1 md:gap-2 bg-slate-100 rounded-lg px-2 md:px-3 py-1.5"
};
const _hoisted_11 = {
  class: "text-xs md:text-sm font-medium text-slate-700 min-w-[100px] md:min-w-[140px] text-center"
};
const _hoisted_12 = {
  class: "md:hidden flex items-center gap-2 px-4 md:px-6 py-2 bg-white border-b border-slate-200 overflow-x-auto"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "flex"
};
const _hoisted_15 = {
  class: "w-56 md:w-64 flex-shrink-0 border-r border-slate-200 bg-white p-3 md:p-4 hidden lg:block"
};
const _hoisted_16 = {
  class: "mb-6"
};
const _hoisted_17 = {
  class: "space-y-2"
};
const _hoisted_18 = ["onUpdate:modelValue"];
const _hoisted_19 = {
  class: "text-sm text-slate-700"
};
const _hoisted_20 = {
  class: "mb-6"
};
const _hoisted_21 = {
  class: "space-y-1"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "flex-1 p-3 md:p-4"
};
const _hoisted_24 = {
  key: 0,
  class: "bg-white rounded-xl border border-slate-200 p-8 text-center"
};
const _hoisted_25 = {
  class: "bg-white rounded-xl border border-slate-200 overflow-hidden"
};
const _hoisted_26 = {
  class: "grid grid-cols-7 border-b border-slate-200"
};
const _hoisted_27 = {
  class: "grid grid-cols-7"
};
const _hoisted_28 = ["onClick", "onContextmenu"];
const _hoisted_29 = {
  class: "flex items-center justify-between mb-1"
};
const _hoisted_30 = {
  key: 0,
  class: "text-xs text-slate-400 hidden sm:inline"
};
const _hoisted_31 = {
  class: "space-y-0.5 md:space-y-1"
};
const _hoisted_32 = ["onClick", "onContextmenu"];
const _hoisted_33 = {
  class: "pl-1.5 md:pl-2"
};
const _hoisted_34 = {
  class: "hidden md:inline text-slate-400 mr-1"
};
const _hoisted_35 = {
  class: "text-slate-700 group-hover:text-slate-900"
};
const _hoisted_36 = {
  key: 0,
  class: "ml-1 inline-flex items-center gap-0.5"
};
const _hoisted_37 = {
  key: 0,
  class: "text-xs text-slate-500 px-1 md:px-2 cursor-pointer hover:text-blue-600"
};
const _hoisted_38 = {
  class: "bg-white rounded-xl border border-slate-200 overflow-hidden"
};
const _hoisted_39 = {
  class: "grid grid-cols-8 border-b border-slate-200"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "text-xs text-slate-500"
};
const _hoisted_42 = {
  class: "max-h-[400px] md:max-h-[600px] overflow-y-auto"
};
const _hoisted_43 = {
  class: "grid grid-cols-8"
};
const _hoisted_44 = {
  class: "border-r border-slate-200"
};
const _hoisted_45 = {
  class: "text-xs text-slate-400 hidden md:inline"
};
const _hoisted_46 = {
  class: "text-xs text-slate-400 md:hidden"
};
const _hoisted_47 = ["onClick", "onContextmenu"];
const _hoisted_48 = ["onClick", "onContextmenu", "onDragstart"];
const _hoisted_49 = {
  class: "flex items-start justify-between gap-1"
};
const _hoisted_50 = {
  class: "flex-1 min-w-0"
};
const _hoisted_51 = {
  class: "text-xs font-medium truncate hidden md:block"
};
const _hoisted_52 = {
  class: "text-xs font-medium truncate md:hidden"
};
const _hoisted_53 = {
  class: "text-xs opacity-75 hidden md:block"
};
const _hoisted_54 = {
  key: 0,
  class: "flex items-center gap-0.5 flex-shrink-0"
};
const _hoisted_55 = ["onClick"];
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  class: "bg-white rounded-xl border border-slate-200 overflow-hidden"
};
const _hoisted_58 = {
  class: "flex"
};
const _hoisted_59 = {
  class: "w-12 md:w-16 flex-shrink-0 border-r border-slate-200"
};
const _hoisted_60 = {
  class: "text-xs text-slate-400"
};
const _hoisted_61 = {
  class: "flex-1 relative"
};
const _hoisted_62 = {
  key: 0,
  class: "absolute left-0 right-0 flex items-center z-10",
  style: {
    "top": "50%"
  }
};
const _hoisted_63 = ["onClick", "onContextmenu", "onDragstart"];
const _hoisted_64 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_65 = {
  class: "flex items-center gap-2 flex-wrap"
};
const _hoisted_66 = {
  class: "text-sm font-semibold"
};
const _hoisted_67 = {
  class: "flex items-center gap-1"
};
const _hoisted_68 = ["onClick"];
const _hoisted_69 = ["onClick"];
const _hoisted_70 = ["onClick"];
const _hoisted_71 = ["onClick"];
const _hoisted_72 = {
  class: "text-base font-semibold text-slate-900 mb-1"
};
const _hoisted_73 = {
  key: 0,
  class: "text-sm text-slate-600 mb-2 line-clamp-2"
};
const _hoisted_74 = {
  class: "flex flex-wrap items-center gap-2 md:gap-4 text-xs text-slate-500"
};
const _hoisted_75 = {
  key: 0,
  class: "flex items-center gap-1"
};
const _hoisted_76 = {
  key: 1,
  class: "flex items-center gap-1"
};
const _hoisted_77 = {
  class: "bg-white rounded-xl border border-slate-200"
};
const _hoisted_78 = {
  class: "p-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_79 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_80 = {
  class: "flex items-center gap-2"
};
const _hoisted_81 = {
  class: "divide-y divide-slate-100"
};
const _hoisted_82 = {
  class: "flex items-center gap-3 mb-4"
};
const _hoisted_83 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_84 = {
  class: "text-xs text-slate-500"
};
const _hoisted_85 = {
  class: "space-y-3"
};
const _hoisted_86 = ["onClick", "onContextmenu"];
const _hoisted_87 = {
  class: "flex-1 min-w-0"
};
const _hoisted_88 = {
  class: "flex items-center gap-2 mb-1 flex-wrap"
};
const _hoisted_89 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_90 = {
  class: "text-base font-semibold text-slate-900 mb-1"
};
const _hoisted_91 = {
  key: 0,
  class: "text-sm text-slate-600 mb-2 line-clamp-2"
};
const _hoisted_92 = {
  class: "flex flex-wrap items-center gap-2 md:gap-4 text-xs text-slate-500"
};
const _hoisted_93 = {
  key: 0,
  class: "flex items-center gap-1"
};
const _hoisted_94 = {
  key: 1,
  class: "flex items-center gap-1"
};
const _hoisted_95 = {
  class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity"
};
const _hoisted_96 = ["onClick"];
const _hoisted_97 = ["onClick"];
const _hoisted_98 = ["onClick"];
const _hoisted_99 = {
  key: 0,
  class: "text-sm text-slate-400 text-center py-4"
};
const _hoisted_100 = {
  key: 0,
  class: "text-sm text-slate-400 text-center py-8"
};
const _hoisted_101 = {
  key: 0,
  class: "w-72 md:w-80 flex-shrink-0 bg-white border-l border-slate-200 p-4 hidden xl:block"
};
const _hoisted_102 = {
  class: "mb-6"
};
const _hoisted_103 = {
  class: "text-sm font-semibold text-slate-900 mb-2"
};
const _hoisted_104 = {
  class: "text-xs text-slate-500"
};
const _hoisted_105 = {
  class: "mb-6"
};
const _hoisted_106 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_107 = {
  class: "space-y-2"
};
const _hoisted_108 = ["onClick"];
const _hoisted_109 = {
  class: "flex items-center gap-2 mb-1"
};
const _hoisted_110 = {
  class: "text-xs font-medium text-slate-700"
};
const _hoisted_111 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_112 = {
  key: 0,
  class: "text-sm text-slate-400 text-center py-4"
};
const _hoisted_113 = {
  class: "space-y-2"
};
const _hoisted_114 = ["onClick"];
const _hoisted_115 = ["src", "alt"];
const _hoisted_116 = {
  class: "flex-1 min-w-0"
};
const _hoisted_117 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_118 = {
  class: "text-xs text-slate-500"
};
const _hoisted_119 = {
  class: "flex items-center justify-between p-6 border-b border-slate-200 shrink-0"
};
const _hoisted_120 = {
  class: "text-xl font-semibold text-slate-900"
};
const _hoisted_121 = {
  class: "flex-1 overflow-y-auto p-6 space-y-4"
};
const _hoisted_122 = {
  key: 0,
  class: "text-amber-600 text-sm"
};
const _hoisted_123 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
};
const _hoisted_124 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_125 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_126 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_127 = ["onClick"];
const _hoisted_128 = {
  key: 1
};
const _hoisted_129 = {
  key: 0
};
const _hoisted_130 = {
  key: 1
};
const _hoisted_131 = {
  class: "text-xs text-slate-400 text-right mt-1"
};
const _hoisted_132 = {
  class: "flex items-center justify-between p-6 border-t border-slate-200 shrink-0"
};
const _hoisted_133 = {
  class: "flex gap-3 ml-auto"
};
const _hoisted_134 = ["disabled"];
const _hoisted_135 = {
  key: 0
};
const _hoisted_136 = {
  key: 1
};
const _hoisted_137 = {
  class: "text-center"
};
const _hoisted_138 = {
  class: "text-sm text-slate-600 mb-6"
};
const _hoisted_139 = {
  class: "flex gap-3"
};
const _hoisted_140 = {
  key: 0,
  class: "fixed bottom-4 right-4 z-50 bg-white rounded-xl shadow-lg border border-slate-200 p-4 w-64"
};
const _hoisted_141 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_142 = {
  class: "space-y-2 text-sm"
};
const _hoisted_143 = {
  class: "text-slate-600"
};
const _hoisted_144 = {
  class: "px-2 py-0.5 bg-slate-100 rounded text-xs text-slate-700 font-mono"
};
import { ref, computed, reactive, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import ContextMenu from './components/ContextMenu/ContextMenu.vue';
import EventTooltip from './components/EventTooltip/EventTooltip.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import ScheduleDetailModal from '@/components/ScheduleDetailModal.vue';
import { useDrag } from '@/composables/useDrag';
import { useKeyboard } from '@/composables/useKeyboard';
import { useValidation } from '@/composables/useValidation';
import { scheduleApi } from '@/api/schedule';
import { meetingApi } from '@/api/meeting';
import { useUserStore } from '@/stores/user';
import AppModal from '@/components/AppModal.vue';

// 视图类型

export default {
  __name: 'ScheduleManagement',
  setup(__props) {
    const calendarViews = [{
      label: '月',
      value: 'month'
    }, {
      label: '周',
      value: 'week'
    }, {
      label: '日',
      value: 'day'
    }, {
      label: '议程',
      value: 'agenda'
    }];

    // 状态
    const currentView = ref('month');
    const currentDate = ref(new Date());
    const selectedDate = ref(null);
    const activeFilter = ref('all');
    const loading = ref(false);
    const saving = ref(false);
    const showCreateModal = ref(false);
    const showEventDetail = ref(false);
    const showDeleteConfirm = ref(false);
    const showShortcuts = ref(false);
    const editingEvent = ref(null);
    const detailLoading = ref(false);
    const detailEvent = ref({});
    const deleteTarget = ref(null);

    // 用户store (用于API请求认证、新建会议默认主持人)
    const userStore = useUserStore();

    // 跳转会议管理（静态路由 /meeting）
    const router = useRouter();
    const goToMeeting = () => {
      router.push('/meeting');
    };

    // 日程列表
    const events = ref([]);
    const pagination = reactive({
      current: 1,
      size: 100,
      total: 0
    });

    // 我的日历
    // const myCalendars = reactive([
    //   { id: 1, name: '工作日历', color: '#3B82F6', visible: true, type: 1 },
    //   { id: 2, name: '个人日历', color: '#10B981', visible: true, type: 2 },
    //   { id: 3, name: '团队日历', color: '#F59E0B', visible: true, type: 3 },
    //   { id: 4, name: '客户日历', color: '#8B5CF6', visible: false, type: 4 }
    // ])

    // 日程类型映射（后端类型 -> 前端类型）
    const typeMap = {
      MEETING: {
        value: 'meeting',
        label: '会议',
        color: '#3B82F6'
      },
      TASK: {
        value: 'task',
        label: '任务',
        color: '#F59E0B'
      },
      CALL: {
        value: 'call',
        label: '电话',
        color: '#10B981'
      },
      DEADLINE: {
        value: 'deadline',
        label: '截止',
        color: '#EF4444'
      },
      OTHER: {
        value: 'other',
        label: '其他',
        color: '#6B7280'
      }
    };

    // 日程类型（用于表单选择，使用后端类型值）
    const eventTypes = reactive([{
      value: 'MEETING',
      label: '会议',
      color: '#3B82F6',
      visible: true
    }, {
      value: 'TASK',
      label: '任务',
      color: '#F59E0B',
      visible: true
    }, {
      value: 'CALL',
      label: '电话',
      color: '#10B981',
      visible: true
    }, {
      value: 'DEADLINE',
      label: '截止',
      color: '#EF4444',
      visible: true
    }, {
      value: 'OTHER',
      label: '其他',
      color: '#6B7280',
      visible: true
    }]);

    // 快捷筛选
    const quickFilters = [{
      value: 'all',
      label: '全部日程'
    }, {
      value: 'today',
      label: '今天的日程'
    }, {
      value: 'week',
      label: '本周日程'
    }, {
      value: 'important',
      label: '重要日程'
    }];

    // 待办事项
    // const pendingTasks = reactive([
    //   { id: 1, title: '准备季度汇报材料', time: '今天 14:00', completed: false },
    //   { id: 2, title: '跟进客户反馈', time: '今天 16:00', completed: false },
    //   { id: 3, title: '更新销售数据', time: '明天 10:00', completed: true }
    // ])

    // 星期
    const weekDays = ['日', '一', '二', '三', '四', '五', '六'];

    // 小时
    const hours = Array.from({
      length: 24
    }, (_, i) => i);

    // 模拟事件数据（降级使用）
    const mockEvents = [{
      id: 1,
      title: '项目启动会议',
      type: 'meeting',
      date: '2024-01-15',
      time: '09:00',
      duration: 90,
      location: '会议室A',
      attendees: '张三、李四',
      description: '讨论项目计划和分工',
      color: '#3B82F6'
    }, {
      id: 2,
      title: '客户电话回访',
      type: 'call',
      date: '2024-01-15',
      time: '14:00',
      duration: 30,
      location: '',
      attendees: '王五',
      description: '跟进产品使用情况',
      color: '#10B981'
    }, {
      id: 3,
      title: '提交季度报告',
      type: 'deadline',
      date: '2024-01-16',
      time: '17:00',
      duration: 0,
      location: '',
      attendees: '',
      description: '完成Q4数据分析报告',
      color: '#EF4444'
    }, {
      id: 4,
      title: '团队周会',
      type: 'meeting',
      date: '2024-01-17',
      time: '10:00',
      duration: 60,
      location: '线上会议',
      attendees: '全体成员',
      description: '分享本周进展',
      color: '#3B82F6'
    }, {
      id: 5,
      title: '合同评审',
      type: 'task',
      date: '2024-01-18',
      time: '15:00',
      duration: 45,
      location: '法务部',
      attendees: '法务小王',
      description: '评审新合同条款',
      color: '#F59E0B'
    }, {
      id: 6,
      title: '产品演示',
      type: 'meeting',
      date: '2024-01-19',
      time: '11:00',
      duration: 60,
      location: '客户现场',
      attendees: '客户方全体',
      description: '向客户展示新产品功能',
      color: '#3B82F6'
    }];

    // 快捷联系人
    const quickScheduleContacts = [{
      id: 1,
      name: '张三',
      company: 'ABC公司',
      avatar: 'https://i.pravatar.cc/100?img=1'
    }, {
      id: 2,
      name: '李四',
      company: 'XYZ集团',
      avatar: 'https://i.pravatar.cc/100?img=2'
    }, {
      id: 3,
      name: '王五',
      company: '123科技',
      avatar: 'https://i.pravatar.cc/100?img=3'
    }];

    // 表单数据（对接后端API）
    const eventForm = reactive({
      title: '',
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      type: 'MEETING',
      location: '',
      attendees: [],
      attendeeUserIds: [],
      description: '',
      projectId: null,
      isAllDay: 0,
      priority: 2,
      isImportant: 0,
      reminderEnabled: 1,
      reminderBefore: 15,
      repeatType: 0,
      color: ''
    });

    // 会议专属字段（新建类型为「会议」时随弹窗扩展，保存分流到会议创建接口）
    const meetingForm = reactive({
      meetingMode: 'OFFLINE',
      location: '',
      onlineLink: '',
      hostId: null
    });

    // 重置会议专属字段：新建时会议方式默认线下，主持人默认当前用户（同 MeetingFormModal）
    function resetMeetingForm() {
      meetingForm.meetingMode = 'OFFLINE';
      meetingForm.location = '';
      meetingForm.onlineLink = '';
      meetingForm.hostId = userStore.userInfo?.userId ?? null;
    }

    // 右键菜单状态
    const contextMenuVisible = ref(false);
    const contextMenuX = ref(0);
    const contextMenuY = ref(0);
    const contextMenuEvent = ref(null);
    const contextMenuTarget = ref(null);

    // 预览气泡状态
    const tooltipVisible = ref(false);
    const tooltipEvent = ref(null);
    const tooltipX = ref(0);
    const tooltipY = ref(0);

    // 拖拽状态
    const {
      isDragging: isDraggingEvent,
      dragData: draggedEvent,
      handleDragStart,
      handleDragEnd
    } = useDrag({
      onDragStart: (e, data) => {
        draggedEvent.value = data;
      },
      onDragEnd: () => {
        draggedEvent.value = null;
      }
    });

    // 验证
    const validation = useValidation({
      rules: {
        title: [{
          required: true,
          message: '请输入日程标题',
          trigger: 'blur'
        }, {
          min: 2,
          max: 200,
          message: '标题长度为2-200字符',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }]
      }
    });

    // 键盘快捷键
    const {
      initDefaultShortcuts,
      getShortcutTips
    } = useKeyboard({
      onKeydown: (e, action) => {
        handleKeyboardAction(action);
      }
    });
    const shortcutList = ref([]);

    // 初始化快捷键
    onMounted(async () => {
      initDefaultShortcuts({
        createEvent: () => openCreateModal(),
        goToToday: () => goToToday(),
        navigatePrev: () => navigateDate(-1),
        navigateNext: () => navigateDate(1),
        switchMonthView: () => switchView('month'),
        switchWeekView: () => switchView('week'),
        switchDayView: () => switchView('day'),
        switchAgendaView: () => switchView('agenda'),
        closeModal: () => closeModal(),
        openSearch: () => toggleShortcuts()
      });
      shortcutList.value = getShortcutTips();

      // 点击其他区域关闭快捷键提示
      document.addEventListener('click', handleOutsideClick);

      // 获取日程数据
      await fetchEvents();
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleOutsideClick);
    });

    // 获取日程列表
    async function fetchEvents() {
      loading.value = true;
      try {
        // 计算日期范围（月视图显示前后1个月的数据以确保完整性）
        const start = new Date(currentDate.value);
        start.setMonth(start.getMonth() - 1);
        start.setDate(1);
        const end = new Date(currentDate.value);
        end.setMonth(end.getMonth() + 2);
        end.setDate(0);

        // 格式化日期为 LocalDateTime 格式 (yyyy-MM-ddTHH:mm:ss)
        const formatLocalDateTime = date => {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, '0');
          const d = String(date.getDate()).padStart(2, '0');
          const h = String(date.getHours()).padStart(2, '0');
          const min = String(date.getMinutes()).padStart(2, '0');
          const s = String(date.getSeconds()).padStart(2, '0');
          return `${y}-${m}-${d}T${h}:${min}:${s}`;
        };
        const params = {
          startTime: formatLocalDateTime(start),
          endTime: formatLocalDateTime(end)
        };
        const res = await scheduleApi.getAllByDateRange(params);
        if (res) {
          // 处理数据
          if (Array.isArray(res)) {
            events.value = res.map(transformEvent);
            pagination.total = res.length;
          } else {
            events.value = [];
          }
        } else {
          // 接口未对接，使用模拟数据
          events.value = mockEvents.map(transformEvent);
        }
      } catch (error) {
        console.error('[Schedule] 获取日程失败:', error);
        ElMessage.error('获取日程数据失败');
        // 降级使用模拟数据
        events.value = mockEvents.map(transformEvent);
      } finally {
        loading.value = false;
      }
    }

    // 转换后端日程数据为前端格式
    function transformEvent(event) {
      if (!event) return null;

      // 解析开始时间（支持两种格式: yyyy-MM-ddTHH:mm:ss 和 yyyy-MM-dd HH:mm:ss）
      const startDateTime = event.startTime;
      let date = '';
      let time = '';
      let duration = event.duration || 60;
      if (startDateTime) {
        // 将空格格式转换为 T 格式，确保跨浏览器兼容
        const normalizedTime = startDateTime.replace(' ', 'T');
        const dt = new Date(normalizedTime);
        if (!isNaN(dt.getTime())) {
          date = dt.toISOString().split('T')[0];
          time = normalizedTime.includes('T') ? normalizedTime.split('T')[1]?.substring(0, 5) : '09:00';
        }
      }

      // 获取类型信息
      const backendType = event.type;
      const typeInfo = typeMap[backendType] || typeMap.OTHER;
      const frontendType = typeInfo.value;

      // 计算结束时间
      let endDate = date;
      let endTime = '';
      if (event.endTime) {
        const normalizedEndTime = event.endTime.replace(' ', 'T');
        const dt = new Date(normalizedEndTime);
        if (!isNaN(dt.getTime())) {
          endDate = dt.toISOString().split('T')[0];
          endTime = normalizedEndTime.includes('T') ? normalizedEndTime.split('T')[1]?.substring(0, 5) : '10:00';
        }
      }

      // 处理参与人
      let attendees = '';
      let attendeeList = [];
      if (event.attendees && Array.isArray(event.attendees)) {
        attendeeList = event.attendees.map(a => ({
          id: a.userId,
          userId: a.userId,
          userName: a.userName || '',
          avatar: a.avatar || '',
          role: a.role,
          status: a.status
        }));
        attendees = event.attendees.map(a => a.userName || '').filter(Boolean).join('、');
      }
      const result = {
        id: event.id,
        title: event.title,
        type: frontendType,
        typeBackend: backendType,
        // 保存后端类型值
        date,
        time,
        duration,
        endDate,
        endTime,
        location: event.location || '',
        description: event.description || '',
        attendees,
        attendeeList,
        color: event.color || typeInfo.color,
        // CRM关联
        customerId: event.customerId,
        customerName: event.customerName || '',
        opportunityId: event.opportunityId,
        opportunityName: event.opportunityName || '',
        contractId: event.contractId,
        contractName: event.contractName || '',
        projectId: event.projectId,
        projectName: event.projectName || '',
        // 状态
        status: event.status,
        isAllDay: event.isAllDay,
        isImportant: event.isImportant,
        priority: event.priority,
        reminderEnabled: event.reminderEnabled,
        reminderBefore: event.reminderBefore,
        repeatType: event.repeatType,
        // 拥有者信息
        isOwner: event.isOwner,
        attendeeStatus: event.attendeeStatus,
        // 创建时间
        createdAt: event.createTime,
        updatedAt: event.updateTime
      };
      return result;
    }

    // 获取日程参与人列表 (供后续参与人管理功能使用)
    async function fetchAttendees(eventId) {
      // eslint-disable-line no-unused-vars
      try {
        const res = await scheduleApi.getAttendees(eventId);
        return res || [];
      } catch (error) {
        console.error('[Schedule] 获取参与人失败:', error);
        return [];
      }
    }

    // 添加参与人
    async function addAttendees(eventId, userIds) {
      // eslint-disable-line no-unused-vars
      try {
        const res = await scheduleApi.addAttendees(eventId, {
          userIds
        });
        ElMessage.success('添加成功');
        return res;
      } catch (error) {
        console.error('[Schedule] 添加参与人失败:', error);
        ElMessage.error('添加失败');
        return null;
      }
    }

    // 移除参与人
    async function removeAttendee(eventId, userId) {
      // eslint-disable-line no-unused-vars
      try {
        await scheduleApi.removeAttendee(eventId, userId);
        ElMessage.success('移除成功');
        return true;
      } catch (error) {
        console.error('[Schedule] 移除参与人失败:', error);
        ElMessage.error('移除失败');
        return false;
      }
    }

    // 响应邀请
    async function respondInvite(eventId, userId, status) {
      // eslint-disable-line no-unused-vars
      try {
        await scheduleApi.responseInvite(eventId, userId, status);
        ElMessage.success('已响应');
        return true;
      } catch (error) {
        console.error('[Schedule] 响应邀请失败:', error);
        ElMessage.error('响应失败');
        return false;
      }
    }

    // 检查时间冲突
    async function checkConflict(params) {
      // eslint-disable-line no-unused-vars
      try {
        const res = await scheduleApi.checkConflict(params);
        return res || [];
      } catch (error) {
        console.error('[Schedule] 检查冲突失败:', error);
        return [];
      }
    }

    // 完成日程
    async function completeSchedule(eventId) {
      // eslint-disable-line no-unused-vars
      try {
        await scheduleApi.complete(eventId);
        ElMessage.success('已完成');
        // 更新本地状态
        const event = events.value.find(e => e.id === eventId);
        if (event) {
          event.status = 'COMPLETED';
        }
        return true;
      } catch (error) {
        console.error('[Schedule] 完成日程失败:', error);
        ElMessage.error('操作失败');
        return false;
      }
    }

    // 取消日程
    async function cancelSchedule(eventId) {
      // eslint-disable-line no-unused-vars
      try {
        await scheduleApi.cancel(eventId);
        ElMessage.success('已取消');
        // 更新本地状态
        const event = events.value.find(e => e.id === eventId);
        if (event) {
          event.status = 'CANCELLED';
        }
        return true;
      } catch (error) {
        console.error('[Schedule] 取消日程失败:', error);
        ElMessage.error('操作失败');
        return false;
      }
    }

    // 格式化日期时间 (供后续使用)
    function formatDateTime(dateStr, timeStr) {
      // eslint-disable-line no-unused-vars
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}日 ${timeStr || ''}`;
    }
    function handleOutsideClick(e) {
      if (!e.target.closest('.event-tooltip') && !e.target.closest('.context-menu')) {
        tooltipVisible.value = false;
      }
      if (!e.target.closest('.context-menu') && !e.target.closest('.context-menu-backdrop')) {
        contextMenuVisible.value = false;
      }
    }
    function handleKeyboardAction(action) {
      const actionMap = {
        create: openCreateModal,
        today: goToToday,
        prev: () => navigateDate(-1),
        next: () => navigateDate(1),
        monthView: () => switchView('month'),
        weekView: () => switchView('week'),
        dayView: () => switchView('day'),
        agendaView: () => switchView('agenda'),
        close: closeModal
      };
      actionMap[action]?.();
    }
    function toggleShortcuts() {
      showShortcuts.value = !showShortcuts.value;
    }

    // 计算属性
    const filteredEvents = computed(() => {
      let result = [...(events.value || [])];

      // 过滤掉 null 值
      result = result.filter(Boolean);

      // 按类型筛选（支持后端类型值）
      const visibleTypes = eventTypes.filter(t => t.visible).map(t => t.value);
      result = result.filter(e => {
        // 支持前端类型值(meeting/task)和后端类型值(MEETING/TASK)
        return visibleTypes.includes(e.type) || visibleTypes.includes(e.typeBackend);
      });

      // 按快捷筛选条件筛选
      const today = new Date().toISOString().split('T')[0];
      const weekStart = new Date();
      weekStart.setDate(weekStart.getDate() - weekStart.getDay());
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      const weekStartStr = weekStart.toISOString().split('T')[0];
      const weekEndStr = weekEnd.toISOString().split('T')[0];
      switch (activeFilter.value) {
        case 'today':
          result = result.filter(e => e.date === today);
          break;
        case 'week':
          result = result.filter(e => e.date >= weekStartStr && e.date <= weekEndStr);
          break;
        case 'important':
          result = result.filter(e => e.isImportant === 1 || e.priority === 1);
          break;
        case 'all':
        default:
          // 全部显示，不做额外筛选
          break;
      }
      return result;
    });

    // 判断是否是被邀请且待定的日程
    const isPendingInvite = event => {
      return event.isOwner === false && event.attendeeStatus === 1;
    };

    // 获取参与状态标签
    const getAttendeeStatusLabel = status => {
      const statusMap = {
        1: {
          label: '待定',
          class: 'status-badge is-warning'
        },
        2: {
          label: '已接受',
          class: 'status-badge is-success'
        },
        3: {
          label: '已拒绝',
          class: 'status-badge is-danger'
        }
      };
      return statusMap[status] || {
        label: '未知',
        class: 'status-badge is-neutral'
      };
    };

    // 响应邀请（接受/拒绝）
    async function respondToInvite(event, status) {
      try {
        await scheduleApi.responseInvite(event.id, status);
        ElMessage.success(status === 2 ? '已接受邀请' : '已拒绝邀请');
        // 刷新列表
        await fetchEvents();
        // 如果详情页打开，重新获取详情以刷新参与人状态
        if (showEventDetail.value && detailEvent.value.id === event.id) {
          const res = await scheduleApi.getDetail(event.id);
          if (res) {
            // 处理参与人列表
            let attendeeList = [];
            let attendeesStr = '';
            if (res.attendees && Array.isArray(res.attendees)) {
              attendeeList = res.attendees.map(a => ({
                id: a.id,
                userId: a.userId,
                userName: a.userName || '',
                avatar: a.avatar || '',
                role: a.role,
                status: a.status
              }));
              attendeesStr = res.attendees.map(a => a.userName || '').filter(Boolean).join('、');
            }
            // 更新详情数据
            detailEvent.value = {
              ...detailEvent.value,
              ...res,
              attendees: attendeesStr,
              attendeeList
            };
          }
        }
        return true;
      } catch (error) {
        console.error('[Schedule] 响应邀请失败:', error);
        ElMessage.error('操作失败');
        return false;
      }
    }
    const formattedDate = computed(() => {
      return currentDate.value.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long'
      });
    });
    const formatSelectedDate = computed(() => {
      if (!selectedDate.value) return '';
      const date = new Date(selectedDate.value.fullDate);
      return date.toLocaleDateString('zh-CN', {
        month: 'long',
        day: 'numeric'
      });
    });
    const navigationDate = computed(() => {
      const year = currentDate.value.getFullYear();
      const month = currentDate.value.getMonth() + 1;
      if (currentView.value === 'month') {
        return `${year}年${month}月`;
      } else if (currentView.value === 'week') {
        const weekStart = new Date(currentDate.value);
        weekStart.setDate(currentDate.value.getDate() - currentDate.value.getDay());
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);
        return `${weekStart.getMonth() + 1}月${weekStart.getDate()}日 - ${weekEnd.getMonth() + 1}月${weekEnd.getDate()}日`;
      } else {
        return `${year}年${month}月${currentDate.value.getDate()}日`;
      }
    });
    const currentDayDate = computed(() => {
      return currentDate.value.toISOString().split('T')[0];
    });
    const today = new Date().toISOString().split('T')[0];
    const currentHour = new Date().getHours();

    // 周日期数据
    const weekDates = computed(() => {
      const dates = [];
      const start = new Date(currentDate.value);
      start.setDate(currentDate.value.getDate() - currentDate.value.getDay());
      for (let i = 0; i < 7; i++) {
        const date = new Date(start);
        date.setDate(start.getDate() + i);
        dates.push({
          date: date.toISOString().split('T')[0],
          weekday: weekDays[i],
          day: date.getDate(),
          isToday: date.toISOString().split('T')[0] === today
        });
      }
      return dates;
    });

    // 日历天数据（月视图）
    const calendarDays = computed(() => {
      const days = [];
      const year = currentDate.value.getFullYear();
      const month = currentDate.value.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      // 上月日期
      const startDay = firstDay.getDay();
      const prevMonth = new Date(year, month, 0);
      for (let i = startDay - 1; i >= 0; i--) {
        const date = prevMonth.getDate() - i;
        days.push({
          date,
          isCurrentMonth: false,
          isToday: false,
          fullDate: `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`,
          events: []
        });
      }

      // 当月日期
      for (let date = 1; date <= lastDay.getDate(); date++) {
        const fullDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
        days.push({
          date,
          isCurrentMonth: true,
          isToday: fullDate === today,
          fullDate,
          events: filteredEvents.value.filter(e => e.date === fullDate)
        });
      }

      // 下月日期
      const remaining = 42 - days.length;
      for (let date = 1; date <= remaining; date++) {
        days.push({
          date,
          isCurrentMonth: false,
          isToday: false,
          fullDate: `${year}-${String(month + 2).padStart(2, '0')}-${String(date).padStart(2, '0')}`,
          events: []
        });
      }
      return days;
    });

    // 议程分组
    const agendaGroups = computed(() => {
      const groups = [];
      const todayStr = new Date().toISOString().split('T')[0];
      const weekLater = new Date();
      weekLater.setDate(weekLater.getDate() + 7);
      const todayEvents = filteredEvents.value.filter(e => e.date === todayStr);
      const upcomingEvents = filteredEvents.value.filter(e => e.date > todayStr && e.date <= weekLater.toISOString().split('T')[0]);
      if (todayEvents.length > 0) {
        groups.push({
          date: todayStr,
          label: '今天',
          events: todayEvents
        });
      }
      if (upcomingEvents.length > 0) {
        groups.push({
          date: 'upcoming',
          label: '即将到来',
          events: upcomingEvents
        });
      }
      return groups;
    });
    const agendaTitle = computed(() => {
      return currentDate.value.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    });

    // 右键菜单项
    const contextMenuItems = computed(() => {
      const items = [{
        key: 'add',
        label: '添加日程',
        icon: 'add',
        priority: 1
      }, {
        type: 'divider'
      }, {
        key: 'edit',
        label: '编辑',
        icon: 'edit',
        priority: 2,
        disabled: !contextMenuEvent.value
      }, {
        key: 'copy',
        label: '复制到明天',
        icon: 'copy',
        priority: 3,
        disabled: !contextMenuTarget.value?.fullDate
      }, {
        type: 'divider'
      }, {
        key: 'delete',
        label: '删除',
        icon: 'delete',
        danger: true,
        priority: 4,
        disabled: !contextMenuEvent.value
      }];
      return items;
    });

    // 方法
    function switchView(view) {
      currentView.value = view;
      // 切换视图时刷新数据
      fetchEvents();
    }
    function navigateDate(direction) {
      const newDate = new Date(currentDate.value);
      if (currentView.value === 'month') {
        newDate.setMonth(newDate.getMonth() + direction);
      } else if (currentView.value === 'week') {
        newDate.setDate(newDate.getDate() + direction * 7);
      } else {
        newDate.setDate(newDate.getDate() + direction);
      }
      currentDate.value = newDate;
      // 导航日期时刷新数据
      fetchEvents();
    }
    function goToToday() {
      currentDate.value = new Date();
    }
    function goToDate(dateStr) {
      currentDate.value = new Date(dateStr);
      switchView('day');
    }
    function selectDate(day) {
      selectedDate.value = {
        fullDate: day.fullDate,
        weekday: weekDays[new Date(day.fullDate).getDay()],
        events: day.events
      };
    }
    function getSelectedDateEvents() {
      if (!selectedDate.value) return [];
      return filteredEvents.value.filter(e => e.date === selectedDate.value.fullDate);
    }
    function getWeekEvents(dateStr) {
      return filteredEvents.value.filter(e => e.date === dateStr);
    }
    function getDayEvents(dateStr) {
      return filteredEvents.value.filter(e => e.date === dateStr);
    }
    function handleTimeSlotClick(day, event) {
      if (event.target.classList.contains('h-12') || event.target.classList.contains('h-16')) {
        // 点击时间槽，创建新日程
        const rect = event.currentTarget.getBoundingClientRect();
        const y = event.clientY - rect.top;
        const hour = Math.floor(y / 64);
        const minute = Math.round(y % 64 / 64 * 60 / 15) * 15;
        const date = day?.date || currentDayDate.value;
        const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
        openCreateModalForDateTime(date, time);
      }
    }
    function openCreateModalForDate(dateStr) {
      eventForm.startDate = dateStr;
      eventForm.endDate = dateStr;
      eventForm.startTime = '09:00';
      eventForm.endTime = '10:00';
      eventForm.type = 'MEETING';
      eventForm.title = '';
      eventForm.location = '';
      eventForm.description = '';
      eventForm.attendees = [];
      eventForm.attendeeUserIds = [];
      eventForm.projectId = null;
      eventForm.isAllDay = 0;
      eventForm.priority = 2;
      eventForm.isImportant = 0;
      eventForm.reminderEnabled = 1;
      eventForm.reminderBefore = 15;
      eventForm.repeatType = 0;
      eventForm.color = '';
      editingEvent.value = null;
      resetMeetingForm();
      validation.clearValidate();
      showCreateModal.value = true;
    }
    function openCreateModalForDateTime(dateStr, timeStr) {
      openCreateModalForDate(dateStr);
      eventForm.startTime = timeStr;
      eventForm.endTime = timeStr;
    }

    // 开始日期变化处理
    function onStartDateChange() {
      // 如果结束日期早于开始日期，自动调整为开始日期
      if (eventForm.endDate && eventForm.endDate < eventForm.startDate) {
        eventForm.endDate = eventForm.startDate;
      }
      // 如果结束时间和开始日期相同，但结束时间早于开始时间，自动调整
      if (eventForm.endDate === eventForm.startDate && eventForm.endTime && eventForm.endTime < eventForm.startTime) {
        eventForm.endTime = eventForm.startTime;
      }
    }

    // 开始时间变化处理
    function onStartTimeChange() {
      // 如果结束日期与开始日期相同，且结束时间早于开始时间，自动调整
      if (eventForm.endDate === eventForm.startDate && eventForm.endTime && eventForm.endTime < eventForm.startTime) {
        eventForm.endTime = eventForm.startTime;
      }
    }
    function openCreateModal() {
      const now = new Date();
      const dateStr = now.toISOString().split('T')[0];
      eventForm.startDate = dateStr;
      eventForm.endDate = dateStr;
      const startMinutes = Math.floor(now.getMinutes() / 15) * 15;
      const endMinutes = (startMinutes + 30) % 60;
      const endHours = now.getHours() + Math.floor((startMinutes + 30) / 60);
      eventForm.startTime = `${String(now.getHours()).padStart(2, '0')}:${String(startMinutes).padStart(2, '0')}`;
      eventForm.endTime = `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`;
      eventForm.type = 'MEETING';
      eventForm.title = '';
      eventForm.location = '';
      eventForm.description = '';
      eventForm.attendees = [];
      eventForm.attendeeUserIds = [];
      eventForm.projectId = null;
      eventForm.isAllDay = 0;
      eventForm.priority = 2;
      eventForm.isImportant = 0;
      eventForm.reminderEnabled = 1;
      eventForm.reminderBefore = 15;
      eventForm.repeatType = 0;
      eventForm.color = '';
      editingEvent.value = null;
      resetMeetingForm();
      validation.clearValidate();
      showCreateModal.value = true;
    }
    function viewEvent(event) {
      // 先显示基本信息，然后加载详情
      detailEvent.value = event;
      showEventDetail.value = true;

      // 获取日程详情
      detailLoading.value = true;
      scheduleApi.getDetail(event.id).then(res => {
        if (res) {
          // 格式化参与人列表
          const attendeeList = res.attendees?.map(a => ({
            id: a.userId,
            userId: a.userId,
            userName: a.userName || '',
            avatar: a.avatar || '',
            role: a.role,
            status: a.status
          })) || [];
          const attendeesStr = res.attendees?.map(a => a.userName || '').filter(Boolean).join('、') || '';

          // 格式化时间
          const formatDate = dt => dt ? new Date(dt).toISOString().split('T')[0] : '';
          const formatTime = dt => dt ? dt.includes('T') ? dt.split('T')[1]?.substring(0, 5) : dt.substring(0, 5) : '';

          // 合并详情数据
          detailEvent.value = {
            ...event,
            ...res,
            attendees: attendeesStr,
            attendeeList,
            // 格式化时间 (新API使用 startTime/endTime)
            date: res.startTime ? formatDate(res.startTime) : event.date,
            time: res.startTime ? formatTime(res.startTime) : event.time,
            endDate: res.endTime ? formatDate(res.endTime) : event.endDate,
            endTime: res.endTime ? formatTime(res.endTime) : event.endTime,
            // CRM关联
            customerName: res.customerName || '',
            opportunityName: res.opportunityName || '',
            contractName: res.contractName || '',
            projectName: res.projectName || '',
            // 保持拥有者信息
            isOwner: event.isOwner,
            attendeeStatus: event.attendeeStatus,
            // 创建和更新时间
            createdAt: res.createTime || event.createdAt || '',
            updatedAt: res.updateTime || event.updatedAt || ''
          };
        }
      }).catch(error => {
        console.error('[Schedule] 获取详情失败:', error);
      }).finally(() => {
        detailLoading.value = false;
      });
    }
    function editEvent(event) {
      editingEvent.value = event;
      showEventDetail.value = false;
      showCreateModal.value = true;

      // 填充表单（支持后端类型值）
      eventForm.title = event.title;
      eventForm.type = event.typeBackend || event.type;
      eventForm.location = event.location || '';
      eventForm.description = event.description || '';
      eventForm.startDate = event.date;
      eventForm.startTime = event.time || '09:00';
      eventForm.endDate = event.endDate || event.date;
      eventForm.endTime = event.endTime || event.time || '10:00';
      // CRM关联
      eventForm.projectId = event.projectId || null;
      // 状态
      eventForm.isAllDay = event.isAllDay || 0;
      eventForm.priority = event.priority || 2;
      eventForm.isImportant = event.isImportant || 0;
      eventForm.reminderEnabled = event.reminderEnabled || 1;
      eventForm.reminderBefore = event.reminderBefore || 15;
      eventForm.repeatType = event.repeatType || 0;
      eventForm.color = event.color || '';
      // 参与人
      eventForm.attendees = event.attendeeList || [];
      eventForm.attendeeUserIds = event.attendeeList?.map(a => a.id) || [];
    }
    function saveEvent() {
      // 验证
      if (!validation.validate(eventForm)) {
        return;
      }

      // 获取当前时间
      const now = new Date();
      const nowDate = now.toISOString().split('T')[0];
      const nowTime = now.toTimeString().substring(0, 5);

      // 验证开始日期不能早于今天
      if (eventForm.startDate < nowDate) {
        eventForm.startDate = nowDate;
        eventForm.startTime = nowTime;
        ElMessage.warning('开始日期不能早于今天，已自动调整为当前时间');
        return;
      }

      // 如果开始日期是今天，开始时间不能早于当前时间
      if (eventForm.startDate === nowDate && eventForm.startTime < nowTime) {
        eventForm.startTime = nowTime;
        ElMessage.warning('开始时间不能早于当前时间，已自动调整为当前时间');
        return;
      }

      // 验证结束时间必须晚于开始时间且不能跨天
      if (eventForm.startDate && eventForm.startTime && eventForm.endDate && eventForm.endTime) {
        // 如果结束日期早于开始日期，自动调整为开始日期
        if (eventForm.endDate < eventForm.startDate) {
          eventForm.endDate = eventForm.startDate;
          eventForm.endTime = eventForm.startTime;
          ElMessage.warning('结束日期不能早于开始日期，已自动调整');
          return;
        }
        const start = new Date(`${eventForm.startDate}T${eventForm.startTime}`);
        const end = new Date(`${eventForm.endDate}T${eventForm.endTime}`);

        // 如果结束时间早于或等于开始时间
        if (end <= start) {
          eventForm.endTime = '';
          ElMessage.warning('结束时间必须晚于开始时间');
          return;
        }

        // 验证不能跨天
        if (eventForm.endDate !== eventForm.startDate) {
          eventForm.endDate = eventForm.startDate;
          eventForm.endTime = '';
          ElMessage.warning('日程不能跨越多天');
          return;
        }
      }
      saving.value = true;

      // 构建API请求数据
      const startDateTime = eventForm.startDate && eventForm.startTime ? `${eventForm.startDate}T${eventForm.startTime}:00` : null;
      const endDateTime = eventForm.endDate && eventForm.endTime ? `${eventForm.endDate}T${eventForm.endTime}:00` : startDateTime;

      // 新建「会议」类型分流到会议创建接口（编辑已有日程仍走日程接口，见下方）
      if (!editingEvent.value && eventForm.type === 'MEETING') {
        saveMeetingFromSchedule(startDateTime, endDateTime);
        return;
      }
      const data = {
        title: eventForm.title,
        type: eventForm.type,
        startDateTime,
        endDateTime,
        location: eventForm.location,
        description: eventForm.description,
        attendeeUserIds: eventForm.attendeeUserIds,
        projectId: eventForm.projectId,
        isAllDay: eventForm.isAllDay,
        priority: eventForm.priority,
        isImportant: eventForm.isImportant,
        reminderEnabled: eventForm.reminderEnabled,
        reminderBefore: eventForm.reminderBefore,
        repeatType: eventForm.repeatType,
        color: eventForm.color || eventTypes.find(t => t.value === eventForm.type)?.color
      };
      const promise = editingEvent.value ? scheduleApi.update(editingEvent.value.id, data) : scheduleApi.create(data);
      promise.then(async res => {
        saving.value = false;
        showCreateModal.value = false;
        if (editingEvent.value) {
          // 更新模式：重新获取详情
          const detailRes = await scheduleApi.getDetail(editingEvent.value.id);
          if (detailRes) {
            const newEvent = transformEvent(detailRes);
            const index = events.value.findIndex(e => e.id === editingEvent.value.id);
            if (index !== -1) {
              events.value[index] = newEvent;
            }
          }
          ElMessage.success('更新成功');
        } else {
          // 创建模式：API返回的是新日程的ID
          const newId = typeof res === 'number' ? res : res?.id || res?.data?.id;
          if (newId) {
            // 获取新创建的日程详情
            const detailRes = await scheduleApi.getDetail(newId);
            if (detailRes) {
              const newEvent = transformEvent(detailRes);
              events.value.push(newEvent);
            }
          } else {
            // 降级：本地创建
            const newIdLocal = Math.max(...events.value.map(e => e.id), 0) + 1;
            events.value.push({
              id: newIdLocal,
              ...eventForm,
              date: eventForm.startDate,
              time: eventForm.startTime,
              duration: 60,
              color: eventTypes.find(t => t.value === eventForm.type)?.color || '#3B82F6'
            });
          }
          ElMessage.success('创建成功');
        }
        editingEvent.value = null;
      }).catch(error => {
        saving.value = false;
        console.error('[Schedule] 保存失败:', error);
        ElMessage.error('保存失败');
      });
    }

    // 日程弹窗新建「会议」：分流到会议创建接口（会议模块建会会自动生成日程，刷新列表即可见）
    async function saveMeetingFromSchedule(startDateTime, endDateTime) {
      // 按会议方式校验必填（与后端 Meeting.validateModeRequirements 一致：OFFLINE 必填地点、ONLINE 必填链接、HYBRID 两者必填）
      if (meetingForm.meetingMode !== 'ONLINE' && !meetingForm.location?.trim()) {
        saving.value = false;
        ElMessage.warning('请输入会议地点');
        return;
      }
      if (meetingForm.meetingMode !== 'OFFLINE' && !meetingForm.onlineLink?.trim()) {
        saving.value = false;
        ElMessage.warning('请输入线上会议链接');
        return;
      }
      const payload = {
        title: eventForm.title,
        meetingType: 'INTERNAL',
        // 后端 MeetingCreateCommand 约定 @JsonFormat yyyy-MM-dd HH:mm:ss（空格格式）
        startTime: startDateTime?.replace('T', ' '),
        endTime: endDateTime?.replace('T', ' '),
        location: meetingForm.meetingMode !== 'ONLINE' ? meetingForm.location : null,
        meetingMode: meetingForm.meetingMode,
        onlineLink: meetingForm.meetingMode !== 'OFFLINE' ? meetingForm.onlineLink : null,
        customerId: null,
        hostId: meetingForm.hostId,
        remark: eventForm.description || null,
        attendeeUserIds: eventForm.attendeeUserIds,
        reminderBefore: eventForm.reminderBefore ?? 15
      };
      try {
        await meetingApi.createMeeting(payload);
        saving.value = false;
        showCreateModal.value = false;
        ElMessage.success('会议已创建');
        // 会议创建成功会自动生成日程，按现有方式整体刷新列表
        await fetchEvents();
      } catch (error) {
        saving.value = false;
        // 错误已由拦截器提示
        console.error('[Schedule] 创建会议失败:', error);
      }
    }
    function confirmDelete(event) {
      deleteTarget.value = event;
      showDeleteConfirm.value = true;
      showEventDetail.value = false;
      showCreateModal.value = false;
    }
    function handleDelete() {
      if (!deleteTarget.value) return;
      const eventId = deleteTarget.value.id;
      scheduleApi.delete(eventId).then(() => {
        // 从列表中移除
        const index = events.value.findIndex(e => e.id === eventId);
        if (index !== -1) {
          events.value.splice(index, 1);
        }
        showDeleteConfirm.value = false;
        deleteTarget.value = null;
        ElMessage.success('删除成功');
      }).catch(error => {
        console.error('[Schedule] 删除失败:', error);
        // 降级本地删除
        const index = events.value.findIndex(e => e.id === eventId);
        if (index !== -1) {
          events.value.splice(index, 1);
        }
        showDeleteConfirm.value = false;
        deleteTarget.value = null;
        ElMessage.success('删除成功');
      });
    }
    function closeModal() {
      showCreateModal.value = false;
      editingEvent.value = null;
      validation.clearValidate();
    }
    function handleContextMenu(e, day) {
      contextMenuX.value = e.clientX;
      contextMenuY.value = e.clientY;
      contextMenuTarget.value = day;
      contextMenuEvent.value = null;
      contextMenuVisible.value = true;
    }
    function handleEventContextMenu(e, event) {
      contextMenuX.value = e.clientX;
      contextMenuY.value = e.clientY;
      contextMenuTarget.value = null;
      contextMenuEvent.value = event;
      contextMenuVisible.value = true;
    }
    function handleContextMenuSelect(item) {
      if (item.key === 'add' && contextMenuTarget.value) {
        openCreateModalForDate(contextMenuTarget.value.fullDate);
      } else if (item.key === 'edit' && contextMenuEvent.value) {
        editEvent(contextMenuEvent.value);
      } else if (item.key === 'copy' && contextMenuTarget.value) {
        // 复制到明天
        const tomorrow = new Date(contextMenuTarget.value.fullDate);
        tomorrow.setDate(tomorrow.getDate() + 1);
        openCreateModalForDate(tomorrow.toISOString().split('T')[0]);
      } else if (item.key === 'delete' && contextMenuEvent.value) {
        confirmDelete(contextMenuEvent.value);
      }
    }
    function validateField(field) {
      validation.validateField(field, eventForm);
    }

    // function toggleTask() {
    //   // 可以在这里调用API更新状态
    // }

    // function deleteTask(taskId) {
    //   const index = pendingTasks.findIndex(t => t.id === taskId)
    //   if (index !== -1) {
    //     pendingTasks.splice(index, 1)
    //   }
    // }

    // function addQuickTodo() {
    //   // 添加快速待办
    // }

    function scheduleWithContact(contact) {
      openCreateModal();
      eventForm.attendees.push({
        id: contact.id,
        name: contact.name,
        avatar: contact.avatar
      });
    }

    // 样式方法
    function getEventClass(type) {
      const classes = {
        meeting: 'status-badge is-info',
        call: 'status-badge is-success',
        task: 'status-badge is-warning',
        deadline: 'status-badge is-danger',
        other: 'status-badge is-neutral'
      };
      return classes[type] || classes.other;
    }
    function getEventBorderClass(type) {
      const classes = {
        meeting: 'bg-blue-500',
        call: 'bg-green-500',
        task: 'bg-amber-500',
        deadline: 'bg-red-500',
        other: 'bg-slate-500'
      };
      return classes[type] || classes.other;
    }
    function getTypeDotClass(type) {
      const classes = {
        meeting: 'bg-blue-500',
        call: 'bg-green-500',
        task: 'bg-amber-500',
        deadline: 'bg-red-500',
        other: 'bg-slate-500'
      };
      return classes[type] || classes.other;
    }
    function getTypeBadgeClass(type) {
      const classes = {
        meeting: 'status-badge is-info',
        call: 'status-badge is-success',
        task: 'status-badge is-warning',
        deadline: 'status-badge is-danger',
        other: 'status-badge is-neutral'
      };
      return classes[type] || classes.other;
    }
    function getTypeLabel(type) {
      // 支持后端类型值(MEETING/TASK)和前端类型值(meeting/task)
      const backendType = type.toUpperCase();
      const labels = {
        MEETING: '会议',
        TASK: '任务',
        CALL: '电话',
        DEADLINE: '截止',
        OTHER: '其他',
        meeting: '会议',
        task: '任务',
        call: '电话',
        deadline: '截止',
        other: '其他'
      };
      return labels[type] || labels[backendType] || '其他';
    }
    function getEventStyle(event) {
      const [hours, minutes] = event.time.split(':').map(Number);
      const top = hours * 64 + minutes / 60 * 64;
      const height = event.duration / 60 * 64;
      return {
        top: `${top}px`,
        height: `${Math.max(height, 32)}px`
      };
    }
    function getDayEventStyle(event) {
      const [hours, minutes] = event.time.split(':').map(Number);
      const top = hours * 64 + minutes / 60 * 64;
      const height = event.duration / 60 * 64;
      return {
        top: `${top}px`,
        height: `${Math.max(height, 60)}px`
      };
    }
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[36] || (_cache[36] = _createElementVNode("div", {
          class: "w-9 h-9 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        })])], -1)), _createElementVNode("div", _hoisted_5, [_cache[35] || (_cache[35] = _createElementVNode("h1", {
          class: "text-lg font-semibold text-slate-900"
        }, "日程管理", -1)), _createElementVNode("p", _hoisted_6, _toDisplayString(formattedDate.value), 1)])]), _createElementVNode("div", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(calendarViews, view => {
          return _createElementVNode("button", {
            key: view.value,
            onClick: $event => switchView(view.value),
            class: _normalizeClass(['px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200', currentView.value === view.value ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'])
          }, _toDisplayString(view.label), 11, _hoisted_8);
        }), 64))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => navigateDate(-1)),
          class: "p-1 hover:bg-white rounded-md transition-colors cursor-pointer",
          title: "上一天/周/月"
        }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
          class: "w-4 h-4 text-slate-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 19l-7-7 7-7"
        })], -1)]))]), _createElementVNode("span", _hoisted_11, _toDisplayString(navigationDate.value), 1), _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => navigateDate(1)),
          class: "p-1 hover:bg-white rounded-md transition-colors cursor-pointer",
          title: "下一天/周/月"
        }, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
          class: "w-4 h-4 text-slate-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))])]), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary hidden sm:inline-flex items-center gap-2",
          onClick: goToMeeting
        }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        })], -1), _createTextVNode(" 会议管理 ", -1)]))]), _createElementVNode("button", {
          onClick: goToToday,
          class: "btn-secondary hidden sm:inline-flex items-center",
          title: "快捷键: T"
        }, " 今天 "), _createElementVNode("button", {
          onClick: openCreateModal,
          class: "btn-primary inline-flex items-center gap-2",
          title: "快捷键: N"
        }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createElementVNode("span", {
          class: "hidden sm:inline"
        }, "新建日程", -1)]))])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(calendarViews, view => {
          return _createElementVNode("button", {
            key: view.value,
            onClick: $event => switchView(view.value),
            class: _normalizeClass(['px-3 py-1.5 text-sm font-medium rounded-md transition-all whitespace-nowrap', currentView.value === view.value ? 'bg-blue-500 text-white' : 'status-badge is-neutral'])
          }, _toDisplayString(view.label), 11, _hoisted_13);
        }), 64))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("aside", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[41] || (_cache[41] = _createElementVNode("h3", {
          class: "text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3"
        }, "日程类型", -1)), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventTypes, type => {
          return _openBlock(), _createElementBlock("label", {
            key: type.value,
            class: "flex items-center gap-3 cursor-pointer"
          }, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": $event => type.visible = $event,
            class: "w-4 h-4 rounded border-slate-300 text-blue-500 focus:ring-blue-500 cursor-pointer"
          }, null, 8, _hoisted_18), [[_vModelCheckbox, type.visible]]), _createElementVNode("span", {
            class: "w-2 h-2 rounded-full",
            style: _normalizeStyle({
              backgroundColor: type.color
            })
          }, null, 4), _createElementVNode("span", _hoisted_19, _toDisplayString(type.label), 1)]);
        }), 128))])]), _createElementVNode("div", _hoisted_20, [_cache[43] || (_cache[43] = _createElementVNode("h3", {
          class: "text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3"
        }, "快捷筛选", -1)), _createElementVNode("div", _hoisted_21, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickFilters, filter => {
          return _createElementVNode("button", {
            key: filter.value,
            onClick: $event => activeFilter.value = filter.value,
            class: _normalizeClass(['w-full flex items-center gap-3 px-3 py-2 text-sm rounded-lg transition-colors cursor-pointer', activeFilter.value === filter.value ? 'status-badge is-info' : 'text-slate-600 hover:bg-slate-50'])
          }, [_cache[42] || (_cache[42] = _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _createTextVNode(" " + _toDisplayString(filter.label), 1)], 10, _hoisted_22);
        }), 64))])])]), _createElementVNode("main", _hoisted_23, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[44] || (_cache[44] = [_createElementVNode("div", {
          class: "inline-flex items-center gap-2 text-slate-500"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 animate-spin",
          fill: "none",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        })]), _createElementVNode("span", null, "加载中...")], -1)]))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, day => {
          return _createElementVNode("div", {
            key: day,
            class: "py-2 md:py-3 text-center text-xs md:text-sm font-medium text-slate-500"
          }, _toDisplayString(day), 1);
        }), 64))]), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['min-h-[80px] md:min-h-[120px] p-1 md:p-2 border-b border-r border-slate-100 transition-colors cursor-pointer', !day.isCurrentMonth ? 'bg-slate-50' : 'bg-white', day.isToday ? 'bg-blue-50/50' : '', 'hover:bg-slate-50']),
            onClick: $event => selectDate(day),
            onContextmenu: _withModifiers($event => handleContextMenu($event, day), ["prevent"])
          }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", {
            class: _normalizeClass(['w-5 h-5 md:w-7 md:h-7 flex items-center justify-center text-xs md:text-sm rounded-full', day.isToday ? 'bg-blue-500 text-white font-semibold' : day.isCurrentMonth ? 'text-slate-900' : 'text-slate-400'])
          }, _toDisplayString(day.date), 3), day.events.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(day.events.length), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.events.slice(0, 3), event => {
            return _openBlock(), _createElementBlock("div", {
              key: event.id,
              onClick: _withModifiers($event => viewEvent(event), ["stop"]),
              onContextmenu: _withModifiers($event => handleEventContextMenu($event, event), ["stop", "prevent"]),
              class: "group relative px-1 md:px-2 py-0.5 md:py-1 rounded text-xs cursor-pointer transition-all hover:bg-slate-100"
            }, [_createElementVNode("div", {
              class: _normalizeClass(['absolute left-0 top-0 bottom-0 w-0.5 rounded-l', getEventBorderClass(event.type)])
            }, null, 2), _createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, _toDisplayString(event.time), 1), _createElementVNode("span", _hoisted_35, _toDisplayString(event.title), 1), isPendingInvite(event) ? (_openBlock(), _createElementBlock("span", _hoisted_36, [...(_cache[45] || (_cache[45] = [_createElementVNode("span", {
              class: "w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"
            }, null, -1), _createElementVNode("span", {
              class: "text-[10px] font-medium text-amber-600"
            }, "待处理", -1)]))])) : !event.isOwner && event.attendeeStatus ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(['ml-1 text-[10px] font-medium', getAttendeeStatusLabel(event.attendeeStatus).class])
            }, _toDisplayString(getAttendeeStatusLabel(event.attendeeStatus).label), 3)) : _createCommentVNode("", true)])], 40, _hoisted_32);
          }), 128)), day.events.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_37, " +" + _toDisplayString(day.events.length - 3) + " 更多 ", 1)) : _createCommentVNode("", true)])], 42, _hoisted_28);
        }), 128))])], 512), [[_vShow, !loading.value && currentView.value === 'month']]), _withDirectives(_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[46] || (_cache[46] = _createElementVNode("div", {
          class: "p-2 md:p-3 border-r border-slate-200"
        }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDates.value, day => {
          return _openBlock(), _createElementBlock("div", {
            key: day.date,
            class: _normalizeClass(['p-2 md:p-3 text-center border-r border-slate-200 last:border-r-0 cursor-pointer', day.isToday ? 'bg-blue-50' : '']),
            onClick: $event => goToDate(day.date)
          }, [_createElementVNode("p", _hoisted_41, _toDisplayString(day.weekday), 1), _createElementVNode("p", {
            class: _normalizeClass(['text-sm md:text-lg font-semibold', day.isToday ? 'text-blue-600' : 'text-slate-900'])
          }, _toDisplayString(day.day), 3)], 10, _hoisted_40);
        }), 128))]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hours), hour => {
          return _openBlock(), _createElementBlock("div", {
            key: hour,
            class: "h-12 md:h-16 border-b border-slate-100 p-1 md:p-1"
          }, [_createElementVNode("span", _hoisted_45, _toDisplayString(hour) + ":00", 1), _createElementVNode("span", _hoisted_46, _toDisplayString(hour) + ":00", 1)]);
        }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDates.value, day => {
          return _openBlock(), _createElementBlock("div", {
            key: day.date,
            class: _normalizeClass(['relative border-r border-slate-200 last:border-r-0', day.isToday ? 'bg-blue-50/30' : '']),
            onClick: $event => handleTimeSlotClick(day, $event),
            onContextmenu: _withModifiers($event => handleContextMenu($event, day), ["prevent"])
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hours), hour => {
            return _openBlock(), _createElementBlock("div", {
              key: hour,
              class: "h-12 md:h-16 border-b border-slate-100"
            });
          }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWeekEvents(day.date), event => {
            return _openBlock(), _createElementBlock("div", {
              key: event.id,
              onClick: _withModifiers($event => viewEvent(event), ["stop"]),
              onContextmenu: _withModifiers($event => handleEventContextMenu($event, event), ["stop", "prevent"]),
              draggable: "true",
              onDragstart: $event => _unref(handleDragStart)($event, event),
              onDragend: _cache[2] || (_cache[2] = (...args) => _unref(handleDragEnd) && _unref(handleDragEnd)(...args)),
              class: _normalizeClass(['absolute left-0.5 right-0.5 rounded-lg p-1 md:p-2 cursor-move transition-all hover:shadow-md hover:scale-[1.02]', getEventClass(event.type), _unref(isDraggingEvent) && _unref(draggedEvent)?.id === event.id ? 'opacity-50' : '']),
              style: _normalizeStyle(getEventStyle(event))
            }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("p", _hoisted_51, _toDisplayString(event.title), 1), _createElementVNode("p", _hoisted_52, _toDisplayString(event.title.substring(0, 4)) + "...", 1), _createElementVNode("p", _hoisted_53, _toDisplayString(event.time), 1), !event.isOwner ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['mt-1 inline-block px-2 py-0.5 rounded text-xs font-medium', getAttendeeStatusLabel(event.attendeeStatus).class])
            }, _toDisplayString(getAttendeeStatusLabel(event.attendeeStatus).label), 3)) : _createCommentVNode("", true)]), isPendingInvite(event) ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("button", {
              onClick: _withModifiers($event => respondToInvite(event, 2), ["stop"]),
              class: "p-1 rounded bg-green-100 hover:bg-green-200 text-green-700 transition-colors",
              title: "接受"
            }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
              class: "w-3 h-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M5 13l4 4L19 7"
            })], -1)]))], 8, _hoisted_55), _createElementVNode("button", {
              onClick: _withModifiers($event => respondToInvite(event, 3), ["stop"]),
              class: "p-1 rounded bg-red-100 hover:bg-red-200 text-red-700 transition-colors",
              title: "拒绝"
            }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
              class: "w-3 h-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_56)])) : _createCommentVNode("", true)])], 46, _hoisted_48);
          }), 128))], 42, _hoisted_47);
        }), 128))])])], 512), [[_vShow, !loading.value && currentView.value === 'week']]), _withDirectives(_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_cache[49] || (_cache[49] = _createElementVNode("div", {
          class: "h-14 border-b border-slate-200"
        }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hours), hour => {
          return _openBlock(), _createElementBlock("div", {
            key: hour,
            class: "h-12 md:h-16 border-b border-slate-100 p-1"
          }, [_createElementVNode("span", _hoisted_60, _toDisplayString(hour) + ":00", 1)]);
        }), 128))]), _createElementVNode("div", _hoisted_61, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hours), hour => {
          return _openBlock(), _createElementBlock("div", {
            key: hour,
            class: "h-12 md:h-16 border-b border-slate-100 relative",
            onClick: _cache[3] || (_cache[3] = $event => handleTimeSlotClick(null, $event))
          }, [currentDayDate.value === _unref(today) && hour === _unref(currentHour) ? (_openBlock(), _createElementBlock("div", _hoisted_62, [...(_cache[50] || (_cache[50] = [_createElementVNode("div", {
            class: "w-2 h-2 rounded-full bg-red-500"
          }, null, -1), _createElementVNode("div", {
            class: "flex-1 h-0.5 bg-red-400"
          }, null, -1)]))])) : _createCommentVNode("", true)]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDayEvents(currentDayDate.value), event => {
          return _openBlock(), _createElementBlock("div", {
            key: event.id,
            onClick: $event => viewEvent(event),
            onContextmenu: _withModifiers($event => handleEventContextMenu($event, event), ["stop", "prevent"]),
            draggable: "true",
            onDragstart: $event => _unref(handleDragStart)($event, event),
            onDragend: _cache[4] || (_cache[4] = (...args) => _unref(handleDragEnd) && _unref(handleDragEnd)(...args)),
            class: _normalizeClass(['absolute left-2 right-2 rounded-xl p-3 md:p-4 cursor-pointer transition-all hover:shadow-lg', getEventClass(event.type), _unref(isDraggingEvent) && _unref(draggedEvent)?.id === event.id ? 'opacity-50' : '']),
            style: _normalizeStyle(getDayEventStyle(event))
          }, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("span", _hoisted_66, _toDisplayString(event.time), 1), _createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs', getTypeBadgeClass(event.type)])
          }, _toDisplayString(getTypeLabel(event.type)), 3), !event.isOwner ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', getAttendeeStatusLabel(event.attendeeStatus).class])
          }, _toDisplayString(getAttendeeStatusLabel(event.attendeeStatus).label), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_67, [event.isOwner ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _withModifiers($event => editEvent(event), ["stop"]),
            class: "p-1.5 hover:bg-white/50 rounded transition-colors cursor-pointer text-slate-500 hover:text-blue-600",
            title: "编辑"
          }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_68)) : _createCommentVNode("", true), event.isOwner ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _withModifiers($event => confirmDelete(event), ["stop"]),
            class: "p-1.5 hover:bg-red-50 rounded transition-colors cursor-pointer text-slate-500 hover:text-red-600",
            title: "删除"
          }, [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_69)) : _createCommentVNode("", true), isPendingInvite(event) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("button", {
            onClick: _withModifiers($event => respondToInvite(event, 2), ["stop"]),
            class: "p-1.5 hover:bg-green-50 rounded transition-colors cursor-pointer text-green-600 hover:text-green-700",
            title: "接受"
          }, [...(_cache[53] || (_cache[53] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_70), _createElementVNode("button", {
            onClick: _withModifiers($event => respondToInvite(event, 3), ["stop"]),
            class: "p-1.5 hover:bg-red-50 rounded transition-colors cursor-pointer text-red-600 hover:text-red-700",
            title: "拒绝"
          }, [...(_cache[54] || (_cache[54] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_71)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("h4", _hoisted_72, _toDisplayString(event.title), 1), event.description ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(event.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_74, [event.location ? (_openBlock(), _createElementBlock("span", _hoisted_75, [_cache[55] || (_cache[55] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(event.location), 1)])) : _createCommentVNode("", true), event.attendees ? (_openBlock(), _createElementBlock("span", _hoisted_76, [_cache[56] || (_cache[56] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(event.attendees), 1)])) : _createCommentVNode("", true)])], 46, _hoisted_63);
        }), 128))])])], 512), [[_vShow, !loading.value && currentView.value === 'day']]), _withDirectives(_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("h3", _hoisted_79, _toDisplayString(agendaTitle.value), 1), _createElementVNode("div", _hoisted_80, [_createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = $event => switchView('day')),
          class: "text-sm text-blue-600 hover:text-blue-700 cursor-pointer"
        }, " 切换日视图 ")])]), _createElementVNode("div", _hoisted_81, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agendaGroups.value, group => {
          return _openBlock(), _createElementBlock("div", {
            key: group.date,
            class: "p-4"
          }, [_createElementVNode("div", _hoisted_82, [_createElementVNode("span", _hoisted_83, _toDisplayString(group.label), 1), _createElementVNode("span", _hoisted_84, "(" + _toDisplayString(group.events.length) + "个日程)", 1)]), _createElementVNode("div", _hoisted_85, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.events, event => {
            return _openBlock(), _createElementBlock("div", {
              key: event.id,
              onClick: $event => viewEvent(event),
              onContextmenu: _withModifiers($event => handleEventContextMenu($event, event), ["stop", "prevent"]),
              class: "flex items-start gap-4 p-4 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer bg-white group"
            }, [_createElementVNode("div", {
              class: _normalizeClass(['w-1 self-stretch rounded-full flex-shrink-0', getEventBorderClass(event.type)])
            }, null, 2), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("span", _hoisted_89, _toDisplayString(event.time), 1), _createElementVNode("span", {
              class: _normalizeClass(['px-2 py-0.5 rounded text-xs', getTypeBadgeClass(event.type)])
            }, _toDisplayString(getTypeLabel(event.type)), 3)]), _createElementVNode("h4", _hoisted_90, _toDisplayString(event.title), 1), event.description ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(event.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_92, [event.location ? (_openBlock(), _createElementBlock("span", _hoisted_93, [_cache[57] || (_cache[57] = _createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            }), _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            })], -1)), _createTextVNode(" " + _toDisplayString(event.location), 1)])) : _createCommentVNode("", true), event.attendees ? (_openBlock(), _createElementBlock("span", _hoisted_94, [_cache[58] || (_cache[58] = _createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            })], -1)), _createTextVNode(" " + _toDisplayString(event.attendees), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_95, [_createElementVNode("button", {
              onClick: _withModifiers($event => editEvent(event), ["stop"]),
              class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer",
              title: "编辑"
            }, [...(_cache[59] || (_cache[59] = [_createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
            })], -1)]))], 8, _hoisted_96), event.isOwner ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _withModifiers($event => confirmDelete(event), ["stop"]),
              class: "p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer",
              title: "删除"
            }, [...(_cache[60] || (_cache[60] = [_createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_97)) : event.attendeeStatus === 1 ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _withModifiers($event => respondToInvite(event, 3), ["stop"]),
              class: "p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer",
              title: "取消参与"
            }, [...(_cache[61] || (_cache[61] = [_createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_98)) : _createCommentVNode("", true)])], 40, _hoisted_86);
          }), 128)), group.events.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_99, " 暂无日程 ")) : _createCommentVNode("", true)])]);
        }), 128)), agendaGroups.value.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_100, " 暂无日程 ")) : _createCommentVNode("", true)])], 512), [[_vShow, !loading.value && currentView.value === 'agenda']])]), selectedDate.value ? (_openBlock(), _createElementBlock("aside", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("h3", _hoisted_103, _toDisplayString(formatSelectedDate.value), 1), _createElementVNode("p", _hoisted_104, _toDisplayString(selectedDate.value.weekday), 1)]), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_cache[62] || (_cache[62] = _createElementVNode("h4", {
          class: "text-xs font-semibold text-slate-500 uppercase tracking-wider"
        }, "今日日程", -1)), _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = $event => openCreateModalForDate(selectedDate.value.fullDate)),
          class: "text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
        }, " + 添加 ")]), _createElementVNode("div", _hoisted_107, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSelectedDateEvents(), event => {
          return _openBlock(), _createElementBlock("div", {
            key: event.id,
            onClick: $event => viewEvent(event),
            class: "p-3 rounded-lg border border-slate-200 hover:border-blue-300 hover:shadow-sm transition-all cursor-pointer"
          }, [_createElementVNode("div", _hoisted_109, [_createElementVNode("span", {
            class: _normalizeClass(['w-2 h-2 rounded-full flex-shrink-0', getTypeDotClass(event.type)])
          }, null, 2), _createElementVNode("span", _hoisted_110, _toDisplayString(event.time), 1)]), _createElementVNode("p", _hoisted_111, _toDisplayString(event.title), 1)], 8, _hoisted_108);
        }), 128)), getSelectedDateEvents().length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_112, " 暂无日程 ")) : _createCommentVNode("", true)])]), _createElementVNode("div", null, [_cache[64] || (_cache[64] = _createElementVNode("h4", {
          class: "text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3"
        }, "快捷日程", -1)), _createElementVNode("div", _hoisted_113, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickScheduleContacts, contact => {
          return _createElementVNode("button", {
            key: contact.id,
            onClick: $event => scheduleWithContact(contact),
            class: "w-full flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 transition-colors text-left cursor-pointer"
          }, [_createElementVNode("img", {
            src: contact.avatar,
            alt: contact.name,
            class: "w-8 h-8 rounded-full flex-shrink-0"
          }, null, 8, _hoisted_115), _createElementVNode("div", _hoisted_116, [_createElementVNode("p", _hoisted_117, _toDisplayString(contact.name), 1), _createElementVNode("p", _hoisted_118, _toDisplayString(contact.company), 1)]), _cache[63] || (_cache[63] = _createElementVNode("svg", {
            class: "w-4 h-4 text-slate-400 flex-shrink-0",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1))], 8, _hoisted_114);
        }), 64))])])])) : _createCommentVNode("", true)]), _createVNode(ContextMenu, {
          visible: contextMenuVisible.value,
          "onUpdate:visible": _cache[7] || (_cache[7] = $event => contextMenuVisible.value = $event),
          items: contextMenuItems.value,
          x: contextMenuX.value,
          y: contextMenuY.value,
          event: contextMenuEvent.value,
          onSelect: handleContextMenuSelect,
          onClose: _cache[8] || (_cache[8] = $event => contextMenuVisible.value = false)
        }, null, 8, ["visible", "items", "x", "y", "event"]), _createVNode(EventTooltip, {
          visible: tooltipVisible.value,
          "onUpdate:visible": _cache[9] || (_cache[9] = $event => tooltipVisible.value = $event),
          event: tooltipEvent.value,
          x: tooltipX.value,
          y: tooltipY.value,
          onEdit: editEvent,
          onDelete: confirmDelete,
          onClose: _cache[10] || (_cache[10] = $event => tooltipVisible.value = false)
        }, null, 8, ["visible", "event", "x", "y"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(_Transition, {
          name: "modal"
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: showCreateModal.value,
            size: "lg",
            onClose: closeModal
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_119, [_createElementVNode("h2", _hoisted_120, _toDisplayString(editingEvent.value ? '编辑日程' : '新建日程'), 1), _createElementVNode("button", {
              onClick: closeModal,
              class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer",
              "aria-label": "关闭"
            }, [...(_cache[65] || (_cache[65] = [_createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])]), _createElementVNode("div", _hoisted_121, [editingEvent.value && eventForm.type === 'MEETING' ? (_openBlock(), _createElementBlock("div", _hoisted_122, " 该日程关联会议管理模块，会议内容请到「会议管理」中编辑 ")) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[66] || (_cache[66] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode(" 日程标题 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => eventForm.title = $event),
              type: "text",
              placeholder: "输入日程标题",
              maxlength: "200",
              class: _normalizeClass(["form-input w-full", ['border-slate-200', _unref(validation).errors.title ? 'border-red-500 focus:ring-red-500' : '']]),
              onBlur: _cache[12] || (_cache[12] = $event => validateField('title'))
            }, null, 34), [[_vModelText, eventForm.title]]), _unref(validation).errors.title ? (_openBlock(), _createElementBlock("p", _hoisted_123, _toDisplayString(_unref(validation).errors.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", null, [_cache[67] || (_cache[67] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode(" 开始日期 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _createVNode(_component_el_date_picker, {
              modelValue: eventForm.startDate,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => eventForm.startDate = $event),
              type: "date",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择开始日期",
              class: "w-full",
              onChange: onStartDateChange
            }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[68] || (_cache[68] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode(" 开始时间 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _createVNode(_component_el_time_picker, {
              modelValue: eventForm.startTime,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => eventForm.startTime = $event),
              format: "HH:mm",
              "value-format": "HH:mm",
              placeholder: "请选择开始时间",
              class: "w-full",
              onChange: onStartTimeChange
            }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_125, [_createElementVNode("div", null, [_cache[69] || (_cache[69] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "结束日期", -1)), _createVNode(_component_el_date_picker, {
              modelValue: eventForm.endDate,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => eventForm.endDate = $event),
              type: "date",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择结束日期",
              class: "w-full"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[70] || (_cache[70] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "结束时间", -1)), _createVNode(_component_el_time_picker, {
              modelValue: eventForm.endTime,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => eventForm.endTime = $event),
              format: "HH:mm",
              "value-format": "HH:mm",
              placeholder: "请选择结束时间",
              class: "w-full"
            }, null, 8, ["modelValue"])])]), _createElementVNode("div", null, [_cache[71] || (_cache[71] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "提醒时间", -1)), _createVNode(_component_el_select, {
              modelValue: eventForm.reminderBefore,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => eventForm.reminderBefore = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "不提醒",
                value: 0
              }), _createVNode(_component_el_option, {
                label: "5分钟前",
                value: 5
              }), _createVNode(_component_el_option, {
                label: "15分钟前",
                value: 15
              }), _createVNode(_component_el_option, {
                label: "30分钟前",
                value: 30
              }), _createVNode(_component_el_option, {
                label: "1小时前",
                value: 60
              }), _createVNode(_component_el_option, {
                label: "1天前",
                value: 1440
              })]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[72] || (_cache[72] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "日程类型", -1)), _createElementVNode("div", _hoisted_126, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventTypes, type => {
              return _openBlock(), _createElementBlock("button", {
                key: type.value,
                onClick: $event => eventForm.type = type.value,
                type: "button",
                class: _normalizeClass(['px-3 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer', eventForm.type === type.value ? 'ring-2 ring-offset-2 ring-blue-500 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200']),
                style: _normalizeStyle(eventForm.type === type.value ? {
                  backgroundColor: type.color
                } : {})
              }, _toDisplayString(type.label), 15, _hoisted_127);
            }), 128))])]), eventForm.type !== 'MEETING' ? (_openBlock(), _createElementBlock("div", _hoisted_128, [_cache[73] || (_cache[73] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "地点", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => eventForm.location = $event),
              type: "text",
              placeholder: "输入地点或选择会议室",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, eventForm.location]])])) : _createCommentVNode("", true), !editingEvent.value && eventForm.type === 'MEETING' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [_createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode(" 会议方式 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _createVNode(_component_el_select, {
              modelValue: meetingForm.meetingMode,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => meetingForm.meetingMode = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "线下",
                value: "OFFLINE"
              }), _createVNode(_component_el_option, {
                label: "线上",
                value: "ONLINE"
              }), _createVNode(_component_el_option, {
                label: "混合",
                value: "HYBRID"
              })]),
              _: 1
            }, 8, ["modelValue"])]), meetingForm.meetingMode !== 'ONLINE' ? (_openBlock(), _createElementBlock("div", _hoisted_129, [_cache[75] || (_cache[75] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode(" 会议地点 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => meetingForm.location = $event),
              type: "text",
              placeholder: "请输入线下会议地点",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, meetingForm.location]])])) : _createCommentVNode("", true), meetingForm.meetingMode !== 'OFFLINE' ? (_openBlock(), _createElementBlock("div", _hoisted_130, [_cache[76] || (_cache[76] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode(" 线上会议链接 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => meetingForm.onlineLink = $event),
              type: "text",
              placeholder: "https://...",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, meetingForm.onlineLink]])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[77] || (_cache[77] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "主持人", -1)), _createVNode(UserSelector, {
              modelValue: meetingForm.hostId,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => meetingForm.hostId = $event),
              placeholder: "默认为自己（组织者）"
            }, null, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[78] || (_cache[78] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "参与人", -1)), _createVNode(UserSelector, {
              modelValue: eventForm.attendeeUserIds,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => eventForm.attendeeUserIds = $event),
              multiple: "",
              placeholder: "点击选择参与人"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[79] || (_cache[79] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => eventForm.description = $event),
              rows: "3",
              placeholder: "添加日程描述",
              maxlength: "500",
              class: "form-textarea"
            }, null, 512), [[_vModelText, eventForm.description]]), _createElementVNode("p", _hoisted_131, _toDisplayString(eventForm.description.length) + "/500", 1)])]), _createElementVNode("div", _hoisted_132, [editingEvent.value && editingEvent.value.isOwner ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[25] || (_cache[25] = $event => confirmDelete(editingEvent.value)),
              type: "button",
              class: "btn-danger-secondary"
            }, " 删除 ")) : editingEvent.value && !editingEvent.value.isOwner && editingEvent.value.attendeeStatus === 1 ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[26] || (_cache[26] = $event => {
                respondToInvite(editingEvent.value, 3);
                closeModal();
              }),
              type: "button",
              class: "btn-danger-secondary"
            }, " 取消参与 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_133, [_createElementVNode("button", {
              onClick: closeModal,
              type: "button",
              class: "btn-secondary"
            }, " 取消 "), _createElementVNode("button", {
              onClick: saveEvent,
              type: "button",
              disabled: saving.value,
              class: "btn-primary"
            }, [saving.value ? (_openBlock(), _createElementBlock("span", _hoisted_135, "保存中...")) : (_openBlock(), _createElementBlock("span", _hoisted_136, "保存"))], 8, _hoisted_134)])])]),
            _: 1
          }, 8, ["visible"])]),
          _: 1
        })])), _createVNode(ScheduleDetailModal, {
          show: showEventDetail.value,
          event: detailEvent.value,
          loading: detailLoading.value,
          onClose: _cache[27] || (_cache[27] = $event => showEventDetail.value = false),
          onEdit: _cache[28] || (_cache[28] = $event => editEvent(detailEvent.value)),
          onAccept: _cache[29] || (_cache[29] = () => respondToInvite(detailEvent.value, 2)),
          onDecline: _cache[30] || (_cache[30] = () => respondToInvite(detailEvent.value, 3)),
          onCancel: _cache[31] || (_cache[31] = () => respondToInvite(detailEvent.value, 3))
        }, null, 8, ["show", "event", "loading"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(_Transition, {
          name: "modal"
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: showDeleteConfirm.value,
            size: "sm",
            "panel-class": "mx-4 p-6",
            onClose: _cache[33] || (_cache[33] = $event => showDeleteConfirm.value = false)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_137, [_cache[80] || (_cache[80] = _createElementVNode("div", {
              class: "w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4"
            }, [_createElementVNode("svg", {
              class: "w-6 h-6 text-red-600",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            })])], -1)), _cache[81] || (_cache[81] = _createElementVNode("h3", {
              class: "text-lg font-semibold text-slate-900 mb-2"
            }, "确认删除", -1)), _createElementVNode("p", _hoisted_138, "确定要删除「" + _toDisplayString(deleteTarget.value?.title) + "」吗？此操作不可恢复。", 1), _createElementVNode("div", _hoisted_139, [_createElementVNode("button", {
              onClick: _cache[32] || (_cache[32] = $event => showDeleteConfirm.value = false),
              type: "button",
              class: "flex-1 px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors cursor-pointer"
            }, " 取消 "), _createElementVNode("button", {
              onClick: handleDelete,
              type: "button",
              class: "flex-1 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors cursor-pointer"
            }, " 删除 ")])])]),
            _: 1
          }, 8, ["visible"])]),
          _: 1
        })])), _createVNode(_Transition, {
          name: "fade"
        }, {
          default: _withCtx(() => [showShortcuts.value ? (_openBlock(), _createElementBlock("div", _hoisted_140, [_createElementVNode("div", _hoisted_141, [_cache[83] || (_cache[83] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "键盘快捷键", -1)), _createElementVNode("button", {
            onClick: _cache[34] || (_cache[34] = $event => showShortcuts.value = false),
            class: "p-1 text-slate-400 hover:text-slate-600 cursor-pointer"
          }, [...(_cache[82] || (_cache[82] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_142, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortcutList.value, shortcut => {
            return _openBlock(), _createElementBlock("div", {
              key: shortcut.key,
              class: "flex items-center justify-between"
            }, [_createElementVNode("span", _hoisted_143, _toDisplayString(shortcut.label), 1), _createElementVNode("kbd", _hoisted_144, _toDisplayString(shortcut.key), 1)]);
          }), 128))])])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};